var React = require('react');
var Griddle = require('griddle-react');

var OrderStatus = require('../../../containers/Admin/Orders/OrderStatus');
var TimeFormatter = require('../../../containers/Formatters/TimeFormatter');
var EstimatedTimeFormatter = require('../../../containers/Formatters/EstimatedTimeFormatter');
var PriceFormatter = require('../../../containers/Formatters/PriceFormatter');

const rowData = [
	{
    	"columnName": "id",
    	"order": 1,
    	"visible": false
	},
	{
		"columnName": "createdAt",
		"order": 2,
		"visible": true,
		"displayName": "Tempo",
		"sortable": false,
		"customComponent": TimeFormatter
	},
	{
		"columnName": "order",
		"order":  3,
		"visible": true,
		"displayName": "Pedido"
	},
	{
		"columnName": "nameClient",
		"order": 4,
		"visible": true,
		"displayName": "Cliente",
		"sortable": false
	},
	{
		"columnName": "phoneClient",
		"order":  5,
		"visible": true,
		"displayName": "Telefone",
		"sortable": false
	},
	{
		"columnName": "aPoint",
		"order":  6,
		"visible": true,
		"displayName": "Ponto A",
		"sortable": false
	},
	{
		"columnName": "bPoint",
		"order":  7,
		"visible": true,
		"displayName": "Ponto B",
		"sortable": false
	},
	{
		"columnName": "cPoint",
		"order":  8,
		"visible": true,
		"displayName": "Ponto C",
		"sortable": false
	},
	{
		"columnName": "dPoint",
		"order":  9,
		"visible": true,
		"displayName": "Ponto D",
		"sortable": false
	},
	{
    	"columnName": "estimatedTime",
    	"order": 10,
    	"visible": true,
    	"displayName": "Tempo estimado",
    	"sortable": false,
    	"customComponent": EstimatedTimeFormatter

	},
	{
    	"columnName": "value",
    	"order": 11,
    	"visible": true,
    	"displayName": "Valor",
    	"sortable": false,
    	"customComponent": PriceFormatter

	},
	{
    	"columnName": "courierValue",
    	"order": 12,
    	"visible": true,
    	"displayName": "Valor Entregador",
    	"sortable": false,
    	"customComponent": PriceFormatter

	},
	{
    	"columnName": "status",
    	"order": 13,
    	"visible": true,
    	"displayName": "Autorizar",
    	"sortable": false,
    	"customComponent": OrderStatus
	}
];

var Open = React.createClass({

	render: function() {
		var me = this;

		return (
			<Griddle 
				results={me.props.data}
				columnMetadata={rowData}
				showFilter={true}
				resultsPerPage={20}
				useGriddleStyles={false}
				tableClassName="table"
				sortDefaultComponent={<span className="icon-sort"></span>}
				sortAscendingComponent={<span className="icon-sort-down"></span>}
				sortDescendingComponent={<span className="icon-sort-up"></span>}
				filterPlaceholderText="Pesquisar"
				nextText="Próxima"
				previousText="Anterior"
				columns={[
					"createdAt", 
					"order",
					"nameClient",
					"phoneClient",
					"aPoint",
					"bPoint",
					"cPoint",
					"dPoint",
					"estimatedTime",
					"value",
					"courierValue",
					"status"
				]}
			/>
		);
	}

});

module.exports = Open;


// WEBPACK FOOTER //
// ./src/components/Admin/Orders/Open.jsx